module.exports = __webpack_public_path__ + "static/media/icon.heart.alone.orange.afa49c94.svg";